<template>
  <section id="newsMainSection" class="news-grexy-section">
    <b-container class="about-grid">
      <b-row>
        <b-col class="col-xs-12" sm="12" md="12" lg="12">
          <h2 class="main-title-section">{{$t('news-title')}}</h2>
        </b-col>
      </b-row>
      <b-row class="bg-box">
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="card-box">
            <img class="image-pre-1" src="../assets/img/profile-img.svg" alt="About image">
            <div class="box-content">
              <p class="box-title" v-html="$t('news_title_1')"></p>
              <p class="box-text" v-html="$t('news_text_1')"></p>
              <router-link class="yellow-btn" to="/about">{{$t('more_details')}}</router-link>
            </div>
          </div>
        </b-col>
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="gradient-box-1">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../assets/img/new-content/rico-eng.png" alt="About image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../assets/img/new-content/rico-ua.png" alt="About image">
            <img v-else class="main-photo" src="../assets/img/about-2-en.png" alt="About image">
          </div>
        </b-col>
      </b-row>

      <b-row class="bg-box">
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="gradient-box-2">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../assets/img/new-content/follow-the-rules-eng.png" alt="Follow the rules image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../assets/img/new-content/follow-the-rules-ua.png" alt="Follow the rules image">
            <img v-else class="main-photo" src="../assets/img/new-content/follow-the-rules-eng.png" alt="Follow the rules image">
          </div>
        </b-col>
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="card-box">
            <img class="image-pre-2" src="../assets/img/new-content/follow-the-rules-bg.svg" alt="About image">

            <div class="box-content">
              <p class="box-title" v-html="$t('news_title_2')"></p>
              <p class="box-text" v-html="$t('news_text_2')"></p>
              <router-link class="yellow-btn" to="/user-info">{{$t('more_details')}}</router-link>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="bg-box">
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="card-box">
            <img class="image-pre-1" src="../assets/img/new-content/news-feed-bg.svg" alt="About image">
            <div class="box-content">
              <p class="box-title" v-html="$t('news_title_3')"></p>
              <p class="box-text" v-html="$t('news_text_3')"></p>
              <router-link class="yellow-btn" to="/news">{{$t('more_details')}}</router-link>
            </div>
          </div>
        </b-col>
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="gradient-box-3">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../assets/img/new-content/news-feed-eng.png" alt="News feed image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../assets/img/new-content/news-feed-ua.png" alt="News feed image">
            <img v-else class="main-photo" src="../assets/img/new-content/news-feed-eng.png" alt="News feed image">
          </div>
        </b-col>
      </b-row>

      <b-row class="bg-box">
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="gradient-box-4">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../assets/img/new-content/friends-ukr.png" alt="Follow the rules image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../assets/img/new-content/friends-ukr.png" alt="Follow the rules image">
            <img v-else class="main-photo" src="../assets/img/new-content/friends-ukr.png" alt="Follow the rules image">
          </div>
        </b-col>
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="card-box">
            <img class="image-pre-2" src="../assets/img/new-content/messenger-bg.svg" alt="About image">

            <div class="box-content">
              <p class="box-title" v-html="$t('news_title_4')"></p>
              <p class="box-text" v-html="$t('news_text_4')"></p>
              <router-link class="yellow-btn" to="/messenger">{{$t('more_details')}}</router-link>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="bg-box">
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="card-box">
            <img class="image-pre-1" src="../assets/img/new-content/support.svg" alt="About image">
            <div class="box-content">
              <p class="box-title" v-html="$t('news_title_5')"></p>
              <p class="box-text" v-html="$t('news_text_5')"></p>
<!--              <router-link class="yellow-btn" to="/news">{{$t('more_details')}}</router-link>-->
            </div>
          </div>
        </b-col>
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="gradient-box-5">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../assets/img/new-content/news-feed-eng.png" alt="News feed image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../assets/img/new-content/news-feed-ua.png" alt="News feed image">
            <img v-else class="main-photo" src="../assets/img/new-content/news-feed-eng.png" alt="News feed image">
          </div>
        </b-col>
      </b-row>

      <b-row class="bg-box">
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="gradient-box-6">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../assets/img/new-content/locations-ua.png" alt="Follow the rules image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../assets/img/new-content/locations-ua.png" alt="Follow the rules image">
            <img v-else class="main-photo" src="../assets/img/new-content/locations-ua.png" alt="Follow the rules image">
          </div>
        </b-col>
        <b-col class="col-xs-6 px-0 px-lg-3" sm="6" md="6" lg="6">
          <div class="card-box">
            <img class="image-pre-2" src="../assets/img/new-content/locations.svg" alt="About image">

            <div class="box-content">
              <p class="box-title" v-html="$t('news_title_6')"></p>
              <p class="box-text" v-html="$t('news_text_6')"></p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.news-grexy-section{
  background: #F6F6F7;
  padding: 80px 0;

  .main-title-section{
    font-family: $main-font;
    font-size: 40px;
    font-weight: 700;
    line-height: 48px;
    text-align: center;
    margin: 0 0 40px 0;
    @media screen and (min-width: 320px) {
      font-size: 32px;
      font-weight: 700;
      line-height: 38.4px;
      text-align: left;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      font-size: 40px;
      font-weight: 700;
      line-height: 48px;
      text-align: center;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .bg-box{
    background: #FFFFFF;
    border-radius: 24px;
    overflow: hidden;
    margin-bottom: 40px;
    @media screen and (min-width: 320px) {
      border-radius: 0;
      margin-bottom: 0;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      border-radius: 24px;
      margin-bottom: 40px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .card-box{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    .yellow-btn{
      margin-top: 32px;
      @media screen and (min-width: 320px) {
        margin-top: 16px;
      }
      @media screen and (min-width: 374px) {
      }
      @media screen and (min-width: 425px) {
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 992px) {
        margin-top: 32px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
  }
  .box-content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 0 58px 58px 58px;
    @media screen and (min-width: 320px) {
      padding: 0 24px 24px 24px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      padding: 0 58px 58px 58px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .image-pre-1{
    margin-top: 58px;
    @media screen and (min-width: 320px) {
      margin-top: 24px;
      width: 100%;
      max-width: 150px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
      max-width: 176px;
    }
    @media screen and (min-width: 768px) {
      max-width: 300px;
    }
    @media screen and (min-width: 992px) {
      margin-top: 58px;
      width: unset;
      max-width: unset;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .box-title{
    font-family: $main-font;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    margin: 0 0 9px 0;
    @media screen and (min-width: 320px) {
      font-size: 16px;
      font-weight: 700;
      line-height: 19.2px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .box-text{
    font-family: $main-font;
    font-size: 16px;
    font-weight: 300;
    line-height: 22.4px;
    text-align: left;
    margin: 0;
    @media screen and (min-width: 320px) {
      font-size: 12px;
      font-weight: 300;
      line-height: 16.8px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      font-size: 16px;
      font-weight: 300;
      line-height: 22.4px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .gradient-box-1{
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(187deg, #FFDC5D 50.13%, #DA9CFB 101.11%);
    width: 100%;
    height: 100%;
    max-width: 496px;
    padding: 58px 0;
    float: right;
    margin-right: -15px;
    @media screen and (min-width: 320px) {
      margin-right: 0;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-right: -15px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    img{
      max-width: 240px;
      width: 100%;
      height: auto;
    }
  }
  .gradient-box-2{
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(169.7deg, #A29BFB 42.05%, #FFD4A3 100.56%);
    width: 100%;
    height: 100%;
    max-width: 496px;
    padding: 58px 0;
    float: left;
    margin-left: -15px;
    @media screen and (min-width: 320px) {
      margin-left: 0;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-left: -15px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    img{
      max-width: 240px;
      width: 100%;
      height: auto;
    }
  }
  .gradient-box-3{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 496px;
    padding: 58px 0;
    float: right;
    margin-right: -15px;
    background: linear-gradient(185.31deg, #FFD4A2 52.13%, #36DBFF 113.43%);
    @media screen and (min-width: 320px) {
      margin-right: 0;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-right: -15px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    img{
      max-width: 240px;
      width: 100%;
      height: auto;
    }
  }
  .gradient-box-4{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 496px;
    padding: 58px 0;
    float: left;
    margin-left: -15px;
    background: linear-gradient(175.57deg, #36DBFF 22.22%, #FFD4A2 98.84%);
    @media screen and (min-width: 320px) {
      margin-left: 0;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-left: -15px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    img{
      max-width: 240px;
      width: 100%;
      height: auto;
    }
  }
  .gradient-box-5{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 496px;
    padding: 58px 0;
    float: right;
    margin-right: -15px;
    background: linear-gradient(190.95deg, #FFD4A2 52.98%, #C1EC7B 98.99%);
    @media screen and (min-width: 320px) {
      margin-right: 0;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-right: -15px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    img{
      max-width: 240px;
      width: 100%;
      height: auto;
    }
  }
  .gradient-box-6{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 496px;
    padding: 58px 0;
    float: left;
    margin-left: -15px;
    background: linear-gradient(185.12deg, #C1EC7B 49.7%, #36DBFF 99.98%);
    @media screen and (min-width: 320px) {
      margin-left: 0;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-left: -15px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    img{
      max-width: 240px;
      width: 100%;
      height: auto;
    }
  }
  .image-pre-2{
    margin-top: 50px;
    @media screen and (min-width: 320px) {
      margin-top: 0;
      width: 100%;
      max-width: 120px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
      max-width: 176px;
    }
    @media screen and (min-width: 768px) {
      max-width: 300px;
    }
    @media screen and (min-width: 992px) {
      margin-top: 50px;
      max-width: unset;
      width: unset;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
}
</style>
